import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { Flex, Input, Select, Typography } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { galeryAction } from 'src/store/Slices/Administrator/GalerySlice';
import { getClubs, getRoles } from 'src/store/Slices/DropDownSlice';
import { authRegister, editUser, getMyInfo, getRoleInfo, getUsers } from 'src/store/Slices/AuthSlice';
import { MaskedInput } from 'antd-mask-input';

const AddEditUsersModal = ({ visible, setVisible, userInfo, setPage, setPageSize }) => {

    const dispatch = useDispatch()

    const [login, setLogin] = useState()
    const [password, setPassword] = useState()
    const [role, setRole] = useState()
    const [fio, setFio] = useState()
    const [clubId, setClubId] = useState()
    const [franchiseId, setFranchiseId] = useState()

    const roles = useSelector(state => state.DropDownSlice.roles)
    const clubs = useSelector(state => state.DropDownSlice.clubs)


    useEffect(() => {
        setLogin()
        setPassword()
        setRole()
        setFio()
        setClubId()
        setFranchiseId()
    }, [visible.flag])


    useEffect(() => {
        console.log(userInfo, clubs)
        if (visible.flag === 'edit') {
            setRole(roles?.data?.value?.find(el => el.label === userInfo?.roleName)?.value)
            setClubId(clubs?.data?.value?.find(el => el.label === userInfo?.clubName)?.value)
            setFranchiseId(userInfo?.franchiseId)
            setFio(userInfo?.fio)
        }
    }, [visible, userInfo, roles, clubs])

    useEffect(() => {
        if (visible.flag === 'edit') {
            dispatch(getRoles())
            dispatch(getClubs())
        }
    }, [visible])

    const onClickSubmit = () => {
        if (visible.flag === 'add') {
            dispatch(authRegister({
                phone: login,
                password: password,
                roleId: role,
                clubId: clubId,
                franchiseId: franchiseId,
                fio: fio
            })).then(() => {
                dispatch(getMyInfo({ username: localStorage.getItem('username') }))
                dispatch(getUsers()).then(() => {
                    setVisible({ open: false, flag: '' })
                    setPage(1)
                    setPageSize(20)
                })
            })
        } else {
            dispatch(editUser({
                id: userInfo?.id,
                roleId: role,
                clubId: clubId,
                franchiseId: franchiseId,
                fio: fio
            })).then(() => {
                dispatch(getMyInfo({ username: localStorage.getItem('username') }))
                dispatch(getUsers()).then(() => {
                    setVisible({ open: false, flag: '' })
                    setPage(1)
                    setPageSize(20)
                })
            })
        }
    }


    return (
        <CModal
            alignment="center"
            visible={visible.open}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible({ open: false, flag: '' }) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    visible.flag === 'add' ? 'Добавить пользователя' : 'Редактировать пользователя'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                    <>
                        {visible.flag === 'add' &&
                            <>
                                <div>
                                    <Typography.Title level={5}>Логин</Typography.Title>
                                    <MaskedInput
                                        className="custom-input"
                                        mask="+{0} (000) 000-00-00"
                                        value={login}
                                        onChange={(e) => { setLogin(e.target.value) }}
                                    />
                                </div>
                                <div>
                                    <Typography.Title level={5}>Пароль</Typography.Title>
                                    <Input
                                        value={password}
                                        onChange={(e) => { setPassword(e.currentTarget.value) }}
                                    />
                                </div>
                            </>
                        }

                        <div>
                            <Typography.Title level={5}>Роль</Typography.Title>
                            <Select
                                style={{ width: '100%' }}
                                placeholder='Выбрать'
                                onClick={() => { visible.flag === 'add' && dispatch(getRoles()) }}
                                value={role}
                                onChange={(e) => { setRole(e) }}
                                options={roles?.data?.value}

                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Клуб</Typography.Title>
                            <Select
                                style={{ width: '100%' }}
                                placeholder='Выбрать'
                                onClick={() => { visible.flag === 'add' && dispatch(getClubs()) }}
                                value={clubId}
                                onChange={(e) => { setClubId(e) }}
                                options={clubs?.data?.value}

                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>ФИО</Typography.Title>
                            <Input
                                value={fio}
                                onChange={(e) => { setFio(e.currentTarget.value) }}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Франшиза</Typography.Title>
                            <Input
                            value={franchiseId}
                            onChange={(e) => setFranchiseId(e.currentTarget.value)}
                            />
                        </div>
                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible({ open: false, flag: '' }) }}
                    className='text-light'
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton onClick={onClickSubmit} className='text-light'>
                    {visible.flag === 'add' ? 'Добавить' : 'Редактировать'}
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default AddEditUsersModal